module.exports = __webpack_public_path__ + "static/media/deleteIcon.6f0b8f93.svg";